import request from 'superagent';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import React from 'react';
import FormErrors from 'helpers/FormErrors';
import I18n from 'helpers/I18n';

class SendUserbar extends React.Component {
  static propTypes = {
    submitURL:         React.PropTypes.string.isRequired,
    submitMethod:      React.PropTypes.oneOf(["POST"]).isRequired,
    userbarToken:      React.PropTypes.string.isRequired,
  }

  state = {
    email:         Cookies.get("email"),
    changingEmail: Cookies.get("email") === undefined,
    submitting:    false,
    submitted:     false,
    errors:        new FormErrors(),
  }

  getModelForSubmit() {
    return {
      account: {
        email:         this.state.email,
        userbar_token: this.props.userbarToken,
      }
    };
  }

  handleEmailChange = (e) => {
    const newEmail = e.target.value;
    this.setState({ email: newEmail });
  }

  handleSendToDifferentEmailClick = (e) => {
    e.preventDefault();
    this.setState({ changingEmail: true });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.state.submitting) {
      return;
    }

    this.setState({ submitting: true, errors: new FormErrors() });
    const modelForSubmit = this.getModelForSubmit();
    request
      .post(this.props.submitURL)
      .send(modelForSubmit)
      .set("X-CSRF-Token", window.SessionManager.getCSRFToken())
      .set("Accept", "application/json")
      .then(_res => {
        this.setState({ submitted: true, submitting: false });
        Cookies.set("email", this.state.email);
      })
      .catch(err => {
        let errors;
        if (err.status === 422) {
          errors = new FormErrors(err.response.body.errors.account, "userbar.errors");
        } else {
          errors = new FormErrors({ errors: ["generic_error"] }, "userbar.errors");
        }
        this.setState({ errors: errors, submitting: false });
      });
  }

  render() {
    if (this.state.submitted) {
      return <div className="p-t-20 p-b-20">{I18n.t("userbar.sent")} {this.state.email}</div>;
    }

    const submitButton = <button className="btn btn-primary" disabled={this.state.submitting}>{I18n.t("userbar.send")}</button>;

    let children;
    if (this.state.changingEmail) {
      children = (
        <div className={classNames({ "has-error": this.state.errors.get("email").hasAny() })}>
          <input type="text"
                 className="form-control"
                 placeholder="Email"
                 defaultValue={this.state.email}
                 onChange={this.handleEmailChange}/>
          { " " }
          {submitButton}
          <span className="help-block text-danger">{this.state.errors.get("email").firstError()}</span>
        </div>
      );
    } else {
      children = (
        <div>
          <p>
            {I18n.t("userbar.will_send_to")} {this.state.email}
          </p>
          <div>
            {submitButton}
            { " " }
            <a href="javascript:;" onClick={this.handleSendToDifferentEmailClick}>
              {I18n.t("userbar.different_email")}
            </a>
          </div>
        </div>
      );
    }

    return (
      <form className={classNames("form-inline p-t-20 p-b-20", { "has-error": this.state.errors.hasAny() })} onSubmit={this.handleSubmit}>
        <h4>{I18n.t("userbar.header")}</h4>
        <p className="p-t-10">{I18n.t("userbar.text")}</p>
        {children}
        <span className="help-block text-danger">{this.state.errors.firstError()}</span>
      </form>
    );
  }
}

export default SendUserbar;



// WEBPACK FOOTER //
// ./app/javascript/components/application/SendUserbar.jsx